var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrgevenIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 109.9 106.4",
    style: {
      enableBackground: "new 0 0 109.9 106.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF6300;}\n\t.st1{fill:#1204A5;}\n\t.st2{fill:#5786FD;}\n\t.st3{fill:#00B6D5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,15.2L46.4,15.2c-4.1,0-7.5-3.3-7.5-7.5c0-4.1,3.3-7.5,7.5-7.5c4.1,0,7.5,3.3,7.5,7.5 C53.9,11.9,50.5,15.2,46.4,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.5,15.2L7.5,15.2C3.3,15.2,0,11.9,0,7.8c0-4.1,3.3-7.5,7.5-7.5c4.1,0,7.5,3.3,7.5,7.5 C14.9,11.9,11.6,15.2,7.5,15.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,50.2c13.8,0,24.9-11.2,24.9-25H39.2c0,5.7-4.6,10.3-10.3,10.3V50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.2,50.2c-13.8,0-24.9-11.2-24.9-25h14.7c0,5.7,4.6,10.3,10.3,10.3V50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.9,25.3L109.9,25.3c0-13.8-11.2-25-25-25c-13.8,0-25,11.2-25,25c0,13.8,11.2,25,25,25 C98.8,50.2,109.9,39.1,109.9,25.3 M74.7,25.3C74.7,19.6,79.3,15,85,15c5.7,0,10.3,4.6,10.3,10.3c0,5.7-4.6,10.3-10.3,10.3 C79.3,35.6,74.7,31,74.7,25.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.7,106.1c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3h14.7c0-13.8-11.2-25-25-25 c-13.8,0-25,11.2-25,25H74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,56.4c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3H60c0,13.8,11.2,25,25,25c13.8,0,25-11.2,25-25 H95.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 56.4,
    className: "st3",
    width: 12.3,
    height: 49.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: -0.7,
    y: 77.8,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -52.2965 41.5713)",
    className: "st3",
    width: 49.5,
    height: 12.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.7,
    y: 56.3,
    className: "st3",
    width: 49.5,
    height: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.7,106.1c0-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3h14.7c0-13.8-11.2-25-25-25 c-13.8,0-25,11.2-25,25H74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.3,56.4c0,5.7-4.6,10.3-10.3,10.3c-5.7,0-10.3-4.6-10.3-10.3H60c0,13.8,11.2,25,25,25c13.8,0,25-11.2,25-25 H95.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrgevenIconLogo);
export default __webpack_public_path__ + "static/media/Orgeven-icon--logo.fcdfe7b21f4d9b84dd060c4191002027.svg";
export { ForwardRef as ReactComponent };